"use strict";

(function(){

$.widget("fotobook.calendarFontOptionsWidget", $.fotobook.containereditorbasecontrol, {
    attribute: null,
    getValue: function(){
        return parseInt(this.options.container.attr("data-" + this.attribute), 10);
    },

    _processClick: function(event){
        var value = this.element.hasClass("active") ? 0 : 1;
        Fotobook.containers.calendar.changeAttribute(this.options.container, this.attribute, value);
    },

    _containerChanged: function(){
        var value = !!this.getValue(),
            enabled = this._checkEnabled();
        this.element.toggleClass("active", enabled && value);
        this._super();
    },
    _checkEnabled: function(){
        return true;
    },
});


$.widget("fotobook.calendarWeekNumbersBoldWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "week_numbers_bold",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.weekNumbersAreVisible(this.options.container);
    },
});

$.widget("fotobook.calendarWeekNumbersItalicWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "week_numbers_italic",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.weekNumbersAreVisible(this.options.container);
    },
});



$.widget("fotobook.calendarDayNamesBoldWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "day_name_font_bold",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.dayNamesAreVisible(this.options.container);
    },
});

$.widget("fotobook.calendarDayNamesItalicWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "day_name_font_italic",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.dayNamesAreVisible(this.options.container);
    },
});


$.widget("fotobook.calendarHolidayTitlesBoldWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "numbers_title_bold",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.holidayTitlesAreVisible();
    },
});

$.widget("fotobook.calendarHolidayTitlesItalicWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "numbers_title_italic",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.holidayTitlesAreVisible();
    },
});


$.widget("fotobook.calendarRegularBoldWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "numbers_bold",
});

$.widget("fotobook.calendarRegularItalicWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "numbers_italic",
});


$.widget("fotobook.calendarHeaderBoldWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "month_bold",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.headerIsVisible(this.options.container);
    },
});

$.widget("fotobook.calendarHeaderItalicWidget", $.fotobook.calendarFontOptionsWidget, {
    attribute: "month_italic",
    _checkEnabled: function(){
        return Fotobook.containers.calendar.headerIsVisible(this.options.container);
    },
});

})();